import React, { createContext, useState, memo } from "react";
import layout2Settings from "./GullLayout/Layout2/Layout2Settings";

export const AppContext = createContext();

const AppProvider = ({ children }) => {
  //#region Layout Settings
  const [layoutSettings, setLayoutSettings] = useState(layout2Settings);
  //#endregion
  //#region Exported State
  const [user, setUser] = useState({});
  const [navData, setNavData] = useState([]);
  const [isLoggedInOtp, setIsLoggedInOtp] = useState(false);
  //#endregion
  //#region Provided Context Value
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  // const [notificationSeen, setNotificationSeen] = useState(null);

  // Retrieve notifications from the backend
  const getNotificationByBackend = (notifications) => {
    if (!notifications) return;

    // Load old notifications from sessionStorage
    const stored = sessionStorage.getItem("multi-notification");
    let existing = stored ? JSON.parse(stored) : [];

    if (Array.isArray(notifications)) {
      // Case: op1 → replace whole list
      existing = notifications.map((n, index) => ({
        id: index,
        type: n.type,
        isSeen: n.isSeen,
      }));
    } else {
      // Case: op2 → update only cancel-status
      // if (notifications.type === "cancel_notification") {
      const updatedCancel = {
        id: notifications.id,
        type:
          notifications.type === "cancel_notification"
            ? "cancel-status"
            : "hold-status",
        isSeen: notifications.isSeen,
      };

      // Replace or add only cancel-status entries
      const foundIndex = existing.findIndex(
        (n) => n.type === updatedCancel.type,
      );
      if (foundIndex !== -1) {
        existing[foundIndex] = updatedCancel;
      } else {
        existing.push(updatedCancel);
      }
      // }
    }

    // Save back
    sessionStorage.setItem("multi-notification", JSON.stringify(existing));
  };

  //  Map sub-section path → notification key
  const getNotificationKey = (path) => {
    if (!path) return null;

    switch (path) {
      case "/admin/flight/booking-history":
        return "hold-status";

      case "/admin/flight/cancel-request":
        return "cancel-status";

      default:
        return null; // no mapping
    }
  };

  //main menu notification function
  const getNotificationSeenMainMenu = () => {
    // debugger;
    // get sessionStorage notifications
    const result = sessionStorage.getItem("multi-notification");
    if (!result) return null;

    const notifications = JSON.parse(result);

    // check if any object has isSeen true
    const hasSeen = notifications.some((n) => n.isSeen == false);

    return hasSeen ?? null;
  };

  // Get notification state for a parent menu item
  const getNotificationSeen = (path) => {
    // debugger;
    if (!path) return null;

    // get sessionStorage notifications
    const result = sessionStorage.getItem("multi-notification");
    if (!result) return null;

    const resObj = JSON.parse(result);
    if (!Array.isArray(resObj)) return null;

    // loop through all sub paths of this item

    const key = getNotificationKey(path);
    // debugger;
    const notif = resObj.find((n) => n.type === key);
    if (notif) {
      return notif; // return first unseen notification
    }
  };

  const appContextValue = {
    layoutSettings,
    setLayoutSettings,
    user,
    setUser,
    navData,
    setNavData,
    getNotificationByBackend,
    getNotificationSeen,
    getNotificationSeenMainMenu,
    setIsLoggedInOtp, ///otp send for use
    isLoggedInOtp, ///otp send for use
    setIsLoadingLogin,
    isLoadingLogin,
  };
  //#endregion

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

export default memo(AppProvider);
